import { EnvironmentName } from '@avesdo-common/src/lib/enums/EnvironmentName';
import { Userpilot } from 'userpilot';

// projects\ng-new\src\app\feature\contracts\angularJS\Scripts\moment-timezone-with-data.js
declare const moment: any;

export function setUserpilotMetadata(iAuthUser, environment: EnvironmentName) {
  Userpilot.identify(`${iAuthUser.email}_${environment}`, {
    name: iAuthUser.name,
    email: iAuthUser.email,
    environment,
    role: formatRole(iAuthUser.role),
    timezone: getTimeZone(),
    company: {
      id: iAuthUser.developerId !== undefined ? `${iAuthUser.developerId}_${environment}` : 'N/A',
      name: iAuthUser.developerName !== undefined ? iAuthUser.developerName : 'N/A',
      orgId: iAuthUser.orgId || null,
      environment
    }
  });
}

export function logoutUserpilot() {
  Userpilot.reset();
}

export function triggerUserpilotEvent(event) {
  Userpilot.trigger(event);
}

function getTimeZone(): string {
  const abbr = moment.tz(moment.tz.guess()).zoneAbbr();
  const utcOffset = moment().format('UTCZ');
  return `${abbr} (${utcOffset})`;
}

function formatRoleString(role: string): string {
  switch (role.toLowerCase()) {
    case 'mp_admin':
      return 'admin';
    case 'mp_sales':
    case 'crm_sales':
      return 'sales';
    case 'mp_developer':
    case 'crm_developer':
      return 'developer';
    case 'mp_realtor':
      return 'realtor';
    case 'mp_marketing':
      return 'marketing';
    case 'mp_purchaser':
      return 'client';
    case 'avesdocs':
      return 'avesdoCS';
    default:
      return role;
  }
}

function formatRole(roles: string | string[]): string {
  if(typeof roles === 'string' || roles instanceof String) {
    return formatRoleString(roles as string);
  }
  const filteredRoles = roles.map(role => {
    return formatRoleString(role);
  }).filter(role => role.toLowerCase() !== 'core_user');
  const i = Math.max(filteredRoles.findIndex(role => role === 'avesdoCS'), 0);
  return filteredRoles[i] ?? '';
}
